



















































































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class JavelinLanding extends Vue {
  showRage = false
  toggleImage () {
    this.showRage = !this.showRage
  }
}
